import { render, staticRenderFns } from "./GalleryExtended.vue?vue&type=template&id=88841696&"
import script from "./GalleryExtended.vue?vue&type=script&lang=js&"
export * from "./GalleryExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88841696')) {
      api.createRecord('88841696', component.options)
    } else {
      api.reload('88841696', component.options)
    }
    module.hot.accept("./GalleryExtended.vue?vue&type=template&id=88841696&", function () {
      api.rerender('88841696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/gallery/GalleryExtended.vue"
export default component.exports